import React from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'next-i18next'
import { DEFAULT_FONT_STYLES, DEFAULT_THEME_COLORS } from 'css/theme'

interface DonorStepHeaderProps {
  title?: string
  subtitle?: string
}

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
`

const Title = styled.h1`
  font-size: ${DEFAULT_FONT_STYLES['--theme-font--title-page__font-size']};
  font-weight: ${DEFAULT_FONT_STYLES['--theme-font--title-page__font-weight']};
  line-height: ${DEFAULT_FONT_STYLES['--theme-font--title-page__line-height']};
  color: ${DEFAULT_THEME_COLORS['--theme-color--neutral-10']};
  margin: 0;
`

const Subtitle = styled.p`
  font-size: ${DEFAULT_FONT_STYLES['--theme-font--body-default__font-size']};
  font-weight: ${DEFAULT_FONT_STYLES['--theme-font--body-default__font-weight']};
  line-height: ${DEFAULT_FONT_STYLES['--theme-font--body-default__line-height']};
  color: ${DEFAULT_THEME_COLORS['--theme-color--neutral-40']};
  margin: 0;
`

const DonorStepHeader: React.FC<DonorStepHeaderProps> = ({ title, subtitle }) => {
  const { t } = useTranslation()

  const displayTitle = title || t('DonorStep.title', 'Help us learn more about you')

  const displaySubtitle =
    subtitle || t('DonorStep.subtitle', 'Knowing our donors better helps us fundraise better.')

  return (
    <HeaderContainer>
      <Title>{displayTitle}</Title>
      <Subtitle>{displaySubtitle}</Subtitle>
    </HeaderContainer>
  )
}

export default DonorStepHeader
